export default interface IHandleFormChangeProps {
    property: string;
    newValue: any;
    eventType?: EventType;
}

export enum EventType {
    ContactChange = 'ContactChange',
}
